import React, { useState } from 'react';

const ArtistSection = () => {
  const [showModal, setShowModal] = useState(false);

  // Gwen's bio data
  const gwenBio = {
    name: "GWEN CROUSE",
    role: "OWNER & ARTISTIC DIRECTOR",
    experience: "30 Years of Experience",
    approach: "My approach to helping clients achieve their dream hair begins with an honest conversation about their lifestyle—specifically, how much time they're willing to dedicate to their hair each day. This allows me to design a custom look—whether it's a precision cut, dimensional color, or extensions—that aligns with both their aesthetic goals and daily routine.",
    specialties: "I specialize in single strand, flat tip, weft and tape in extensions. I'm also a Goldwell color specialist. I love doing any type of hair color! I always joke and say Goldwell color runs through my veins!!",
    certifications: "Goldwell Color Trilogy Certification • Malia Extensions • Aqua Extensions • Great Lengths Extensions • Dreamcatcher Extensions • Donna Bella Extensions • Remi Cachet Extensions • Multiple advanced precision cutting classes • Multiple advanced blonding seminars",
    favoriteServices: "I love doing hair extensions paired with a gorgeous color. It's such a huge transformative combination and it's so fun to create. I also love a good color correction. To be able to help someone when they are so unhappy with their hair is so rewarding. I feel that everyone should love their hair! It's so important.",
    inspiration: "My inspiration is my clients. I have spent 30 years behind the chair and 20 as a salon owner. The relationship I have with my clients is so rewarding and special to me. I really look forward to seeing them every few weeks. I feel that becoming a hairdresser and a salon owner has given my life so much purpose and joy. My Hair To Dye For team is also a huge inspiration to me. I'm privileged to work with wonderful girls. I get to spend the day with people that I truly love. It's been such a rewarding journey being a salon owner and watching my stylists come into their own.",
    funFact: "I am very adventurous. I'm passionate about traveling. I especially love taking cruises that let me unwind and explore new places. I also enjoy practicing yoga to stay centered and grounded. At home, I'm kept on my toes by two spirited Chihuahuas, Stevie Nicks and Stuart Little, who definitely run the show!",
    quote: "You get one wild and precious life, so go live it in a way that makes you proud."
  };
  

  // Bio Modal Component
  const BioModal = ({ bio, onClose }) => {
    if (!bio) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center p-4 overflow-y-auto">
        <div className="bg-black text-white max-w-2xl w-full max-h-[90vh] overflow-y-auto relative rounded-lg">
          {/* Close button */}
          <button 
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors z-10 text-2xl"
          >
            ✕
          </button>

          {/* Content */}
          <div className="p-8 md:p-12">
            {/* Header */}
            <div className="text-left mb-8">
              <h2 className="text-3xl md:text-4xl font-bold mb-2" style={{ fontFamily: 'Montserrat, sans-serif', letterSpacing: '0.1em' }}>
                {bio.name}
              </h2>
              {bio.role && (
                <p className="text-[#C7A064] text-lg" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  {bio.role}
                </p>
              )}
              {bio.experience && (
                <p className="text-[#C7A064] text-lg" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  {bio.experience}
                </p>
              )}
            </div>

            {/* Bio Sections */}
            <div className="space-y-6 text-left">
              {bio.approach && (
                <div>
                  <p className="text-gray-300 leading-relaxed" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    {bio.approach}
                  </p>
                </div>
              )}

              {bio.specialties && (
                <div>
                  <h3 className="text-[#C7A064] text-xl mb-3" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    Primary Specialties
                  </h3>
                  <p className="text-gray-300" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    {bio.specialties}
                  </p>
                </div>
              )}

              {bio.certifications && (
                <div>
                  <h3 className="text-[#C7A064] text-xl mb-3" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    Certifications or Advanced Training Completed
                  </h3>
                  <p className="text-gray-300" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    {bio.certifications}
                  </p>
                </div>
              )}

              {bio.favoriteServices && (
                <div>
                  <h3 className="text-[#C7A064] text-xl mb-3" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    Favorite Services
                  </h3>
                  <p className="text-gray-300" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    {bio.favoriteServices}
                  </p>
                </div>
              )}

              {bio.inspiration && (
                <div>
                  <h3 className="text-[#C7A064] text-xl mb-3" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    My Inspiration
                  </h3>
                  <p className="text-gray-300" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    {bio.inspiration}
                  </p>
                </div>
              )}

              {bio.funFact && (
                <div>
                  <h3 className="text-[#C7A064] text-xl mb-3" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    Fun Fact or Something Unique About Me
                  </h3>
                  <p className="text-gray-300" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    {bio.funFact}
                  </p>
                </div>
              )}

              {bio.quote && (
                <div className="pt-6 border-t border-gray-700">
                  <p className="text-[#C7A064] italic text-lg" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    "{bio.quote}"
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const handleViewMore = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <div className="w-full bg-black py-12 sm:py-16 lg:py-24">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Desktop Layout - Hidden on Mobile/Tablet */}
        <div className="hidden lg:grid grid-cols-[200px_1fr_340px] gap-12">
          
          {/* Left Column - Small Image */}
          <div style={{ marginTop: 100 }}>
            <div style={{ height: '180px' }}></div>
            <div className="relative overflow-hidden w-[200px] h-[300px]">
              <img
                src="/images/Artists/Gwen.webp"
                alt="Gwen Crouse"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Center Column - Text Content */}
          <div className="text-white">
            {/* Name and Title - Right aligned */}
            <div className="text-right">
              <h2 className="font-montserrat font-bold text-5xl mb-2 tracking-wider leading-tight">
                GWEN
              </h2>
              <h2 className="font-montserrat font-bold text-5xl mb-4 tracking-wider leading-tight">
                CROUSE
              </h2>
              
              <p 
  style={{
    fontFamily: 'Montserrat',
                         fontWeight: 400,
                         fontStyle: 'Regular',
                         fontSize: '12px',
                         color: '#f8f8f8ff',
                         letterSpacing: '.2em',
                         lineHeight: '100%'
  }}
>
  OWNER & ARTISTIC DIRECTOR
</p>
            </div>
            
            {/* Description */}
            <div className="text-left mt-4">
              <div className="space-y-3 mb-8" style={{ marginTop: 146 }}>
                <p className="font-montserrat text-sm leading-relaxed" style={{ color: "#FAFAFA" }}>
                  Welcome to Hair To Dye For, where luxury meets artistry. Nestled in the heart of 
                  Easton, our high-end salon caters exclusively to woman who expect nothing less than 
                  perfection. We specialize in premium hair extensions, custom color, balayage, and 
                  transformative hair experiences tailored to elevate your natural beauty.
                </p>
                
                <p className="font-montserrat text-sm leading-relaxed text-gray-200">
                  Our elite team of extension and color experts works with the highest-quality products 
                  and techniques to deliver flawless results. Whether you're seeking seamless length, 
                  volume, or a signature color that turns heads, Hair To Dye For is the destination for 
                  woman who demand the best.
                </p>
              </div>
              
              {/* Signature Quote */}
              <div>
                <p 
                  className="text-2xl italic text-white"
                  style={{ fontFamily: 'Montserrat',fontSize: '16px', fontStyle: 'normal',fontWeight: 600,letterSpacing: '3.2px' }}
                >
                  "Excited to meet you all, Gwen."
                </p>
                
                {/* Get To Know Your Stylist Button */}
                <div className="flex justify-left mt-6">
                  <button 
                    onClick={handleViewMore}
                    className="text-[#C7A064] font-montserrat text-xs sm:text-sm font-medium tracking-[0.2em] uppercase hover:text-[#b08954] transition-colors duration-300 pb-1 border-b-2 border-[#C7A064] hover:border-[#b08954]"
               style={{
              
              fontWeight: '700',
            
            }}>
                    Get To Know Your Stylist
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Large Image */}
          <div>
            <div className="relative overflow-hidden w-[340px] h-[510px]">
              <img
                src="/images/Artists/Gwen_1.webp"
                alt="Gwen Crouse"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
        
        {/* Mobile/Tablet Layout - Responsive Stack */}
        <div className="lg:hidden flex flex-col">
          {/* Mobile: Name and Title at top */}
          <div className="text-center text-white mb-6 sm:mb-8">
            <h2 className="font-montserrat font-bold text-3xl sm:text-4xl mb-2 tracking-wider leading-tight">
              GWEN
            </h2>
            <h2 className="font-montserrat font-bold text-3xl sm:text-4xl mb-3 sm:mb-4 tracking-wider leading-tight">
              CROUSE
            </h2>
            <p 
  style={{
     fontFamily: 'Montserrat',
                         fontWeight: 400,
                         fontStyle: 'Regular',
                         fontSize: '12px',
                         color: '#f8f8f8ff',
                         letterSpacing: '.2em',
                         lineHeight: '100%'
  }}
>
  OWNER & ARTISTIC DIRECTOR
</p>
          </div>

          {/* Mobile: First image - Responsive Aspect Ratio */}
          <div className="flex justify-center mb-6 sm:mb-8">
            <div className="w-full max-w-[340px] sm:max-w-[400px]">
              <div className="aspect-[2/3] w-full overflow-hidden">
                <img
                  src="/images/Artists/Gwen_1.webp"
                  alt="Gwen Crouse"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

          {/* Mobile: Text Content - Responsive Padding */}
          <div className="text-white mb-6 sm:mb-8 px-2 sm:px-4">
            <div className="space-y-3 mb-5 sm:mb-6">
              <p className="font-montserrat text-xs sm:text-sm leading-relaxed" style={{ color: "#FAFAFA" }}>
                Welcome to Hair To Dye For, where luxury meets artistry. Nestled in the heart of 
                Easton, our high-end salon caters exclusively to woman who expect nothing less than 
                perfection. We specialize in premium hair extensions, custom color, balayage, and 
                transformative hair experiences tailored to elevate your natural beauty.
              </p>
              
              <p className="font-montserrat text-xs sm:text-sm leading-relaxed text-gray-200">
                Our elite team of extension and color experts works with the highest-quality products 
                and techniques to deliver flawless results. Whether you're seeking seamless length, 
                volume, or a signature color that turns heads, Hair To Dye For is the destination for 
                woman who demand the best.
              </p>
            </div>
            
            {/* Signature Quote - Responsive Text Size */}
            <div className="text-center">
              <p 
                className="text-lg sm:text-xl italic text-white"
                                 style={{ fontFamily: 'Montserrat',fontSize: '16px', fontStyle: 'normal',fontWeight: 600,letterSpacing: '3.2px' }}

              >
                "Excited to meet you all, Gwen."
              </p>
              
              {/* Get To Know Your Stylist Button */}
              <div className="flex justify-center mt-6">
                <button 
                  onClick={handleViewMore}
                  className="text-[#C7A064] font-montserrat text-xs sm:text-sm font-medium tracking-[0.2em] uppercase hover:text-[#b08954] transition-colors duration-300 pb-1 border-b-2 border-[#C7A064] hover:border-[#b08954]"
               style={{
              
              fontWeight: '700',
            
            }}>
                  Get To Know Your Stylist
                </button>
              </div>
            </div>
          </div>

          {/* Mobile: Second image - Responsive */}
          <div className="flex justify-center">
            <div className="w-full max-w-[200px] sm:max-w-[250px]">
              <div className="aspect-[2/3] w-full overflow-hidden">
                <img
                  src="/images/Artists/Gwen.webp"
                  alt="Gwen Crouse"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Bio Modal */}
      {showModal && (
        <BioModal 
          bio={gwenBio} 
          onClose={closeModal}
        />
      )}
    </div>
  );
};

export default ArtistSection;